import { IApplicationState } from '../../types/redux';

export function selectAdfoxRequestedParams(state: IApplicationState) {
  return state.adfoxParams;
}
